import ScrollProgress from "./motion/ScrollProgress";
import Navbar from "./components/Navbar/navbar";
import Home from "./components/home/home";
import About from "./components/about/about";
import Specialties from "./components/specialties/specialties";
import Doctors from "./components/doctors/doctors";
import BlogTeaser from "./components/blog/BlogTeaser";
import Gallery from "./components/gallery/gallery";
import Faq from "./components/faq/Faq";
import Visit from "./components/contact/contact";
import Footer from "./components/footer/footer";

function App() {
  return (
    <>
      <ScrollProgress />
      <Navbar />
      <main id="main">
        <Home />
        <About />
        <Specialties />
        <Doctors />
        <BlogTeaser />
        <Gallery />
        <Faq />
        <Visit />
      </main>
      <Footer />
    </>
  );
}

export default App;
